import { useQuery } from '@tanstack/react-query'
import { fetchServices } from '../api'

export const useServices = () =>
  useQuery({
    queryKey: ['services'],
    queryFn: fetchServices,
    staleTime: 30_000,
  })
